import styled from 'styled-components';

export const VitalItemSC = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 0 16px 0 rgba(51, 61, 108, 0.1);
  margin-bottom: 16px;

  .vi-header {
    display: flex;
    align-items: center;
    height: 54px;
    border-bottom: 2px solid #f5f5f7;
    padding-left: 16px;
    padding-right: 6px;

    h6 {
      font-size: 16px;
      font-weight: 600;
      opacity: 0.6;
      margin-bottom: 0;
    }
  }

  .vi-header-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .vi-header-action {
    margin-left: auto;
  }

  .vi-body {
    display: flex;
    align-items: center;
    height: 134px;
  }

  .vi-chart-col {
    width: 45%;
  }

  .vi-data-col {
    width: 55%;
  }

  .vi-data-row {
    display: flex;
    font-size: 13px;
    margin-bottom: 10px;
    word-break: break-all;
    padding-right: 15px;
    overflow-wrap: break-word;
    hyphens: manual;

    span {
      opacity: 0.6;
      min-width: 70px;
      font-weight: 600;
    }

    b {
      font-weight: 800;
      word-break: break-word;
    }
  }
`;

export const VitalItemFooterSC = styled.div<{ hasDetail: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 2px solid #f5f5f7;
  height: 54px;
  padding: 0 16px 0 24px;

  button {
    visibility: ${(props) => (props.hasDetail ? 'visible' : 'hidden')};
  }
`;
